import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect, ConnectedProps } from 'react-redux';
import { Navigate } from 'react-router-dom';
import {
  AppBar,
  Tabs,
  Tab,
} from '@mui/material';

import TrialManagementTab from './TrialManagementTab';
import InstituteManagementView from './InstituteManagementView';

import { RootState } from '../../redux/types';
import withRouter, { RouteType } from '../../hoc/withRouter';
import UserManagerTab from './UserManagerTab';

const AdminView: React.FC<Props> = ({
  router,
  userRole,
}: Props) => {
  if (userRole !== 'admin') {
    <Navigate to="/" />;
  }

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: 'primary.dark' }}>
        <Tabs
          value={router.location.hash || '#trials'}
          textColor="inherit"
          indicatorColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label={<FormattedMessage id="adminview.userManagementTab" />}
            onClick={() => router.navigate('/admin#user')}
            value="#user"
          />
          <Tab
            label={<FormattedMessage id="menu.institute" />}
            onClick={() => router.navigate('/admin#institute')}
            value="#institute"
          />
          <Tab
            label={<FormattedMessage id="adminview.trialManagementTab" />}
            onClick={() => router.navigate('/admin#trials')}
            value="#trials"
          />
        </Tabs>
      </AppBar>
      <div>
        {
          router.location.hash === '#user' && (
            <UserManagerTab />
          )
        }
        {
          router.location.hash === '#institute' && (
            <InstituteManagementView />
          )
        }
        {
          router.location.hash === '#trials' && (
            <TrialManagementTab navigate={router.navigate} />
          )
        }
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  userRole: state.users.token ? state.users.token.role : '',
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type LocationProps = RouteType;
type Props = LocationProps & PropsFromRedux;
export default connector(withRouter(AdminView));
